/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class RubricRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return this.store.findRecord('reports/rubric', params.rubric_id);
  }

  setupController(controller, rubric) {
    super.setupController(controller, rubric);
    controller.loadRubric(rubric);
  }
}
